import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiDetail } from "react-icons/bi";
import { BsBadge3D } from "react-icons/bs";
import { FaCode, FaCoffee, FaGamepad, FaGithub, FaRobot, FaMicrophone, FaStar, FaGlobe, FaWater, FaCloud } from "react-icons/fa";
import { HiTerminal } from "react-icons/hi";
import { IoVideocam, IoVolumeMedium } from "react-icons/io5";
import { MdKeyboardAlt, MdOutlineDesktopWindows } from "react-icons/md";
import { VscEditorLayout } from "react-icons/vsc";
import { Context } from "../../context";
import classes from "./Experiments.module.css";

const ExperimentsCard = ({ card, terminal, setTerminal, setViewMode }) => {
  const navigate = useNavigate();
  const parse = require("html-react-parser");
  const { debug, lang } = useContext(Context);
  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const handleClick = (id) => {
    if (id === 1) {
      setViewMode("terminal2d");
    } else if (id === 2) {
      setViewMode("os2d");
    } else if (id === 3) {
      setViewMode("editor2d");
    } else if (id === 4) {
      setViewMode("coinop2d");
    } else if (id === 5) {
      setViewMode("audio2d");
    } else if (id === 6) {
      setViewMode("video2d");
    } else if (id === 7) {
      setViewMode("c642d");
    } else if (id === 8) {
      setViewMode("code2d");
    } else if (id === 10 || id === 11) {
      if (card.url) {
        window.open(card.url, "_blank");
        return;
      }
    } else {
      setViewMode("terminal2d");
    }
    setTerminal(true);
  };

  const handleClick3d = (id) => {
    if (id === 1) {
      setViewMode("terminal3d");
    } else if (id === 2) {
      setViewMode("os3d");
    } else if (id === 3) {
      setViewMode("editor3d");
    } else if (id === 4) {
      setViewMode("coinop3d");
    } else if (id === 5) {
      setViewMode("audio3d");
    } else if (id === 6) {
      setViewMode("video3d");
    } else if (id === 7) {
      setViewMode("c643d");
    } else if (id === 8) {
      setViewMode("code3d");
    } else {
      setViewMode("terminal3d");
    }
    setTerminal(true);
  };

  const icons = (id) => {
    if (id === 1) {
      return <HiTerminal className={classes.menuIcon} />;
    } else if (id === 2) {
      return <MdOutlineDesktopWindows className={classes.menuIcon} />;
    } else if (id === 3) {
      return <VscEditorLayout className={classes.menuIcon} />;
    } else if (id === 4) {
      return <FaCoffee className={classes.menuIcon} />;
    } else if (id === 5) {
      return <IoVolumeMedium className={classes.menuIcon} />;
    } else if (id === 6) {
      return <IoVideocam className={classes.menuIcon} />;
    } else if (id === 7) {
      return <MdKeyboardAlt className={classes.menuIcon} />;
    } else if (id === 8) {
      return <FaCode className={classes.menuIcon} />;
    } else if (id === 10) {
      return <FaGamepad className={classes.menuIcon} />;
    } else if (id === 11) {
      return <FaRobot className={classes.menuIcon} />;
    } else if (id === 12) {
      return <FaStar className={classes.menuIcon} />;
    } else if (id === 13) {
      return <FaGlobe className={classes.menuIcon} />;
    } else if (id === 14) {
      return <FaWater className={classes.menuIcon} />;
    } else if (id === 15) {
      return <FaRobot className={classes.menuIcon} />;
    } else if (id === 16) {
      return <FaCloud className={classes.menuIcon} />;
    } else {
      return <HiTerminal className={classes.menuIcon} />;
    }
  };

  return (
    <div className="col-md-6 my-1">
      <div className={`${classes.cardWrapper} mb-5`}>
        <div
          key={"democard" + card.id}
          style={{ overflow: "hidden" }}
          className={classes.openedCard2}
        >
          {/* BASH HEADER */}
          <div className={classes.titleBarLight}>
            <div className={classes.dots}>
              <div className={`${classes.dot} ${classes.dotRed}`}></div>
              <div className={`${classes.dot} ${classes.dotYellow}`}></div>
              <div className={`${classes.dot} ${classes.dotGreen}`}></div>
            </div>
            <div className={classes.tabLight}>
              {card.file || "experiment.js"}
            </div>
          </div>

          <div className={classes.experimentCardBody}>
            <div 
              className={classes.imgContainer}
              onClick={() => {
                if (card.url) {
                  if (card.url === "/experiments/cloud-player" && window.innerWidth <= 768) {
                    window.open("http://cloud-player.webdemo.cloud/", "_blank");
                  } else if (card.url.startsWith("/")) {
                    navigate(card.url);
                  } else {
                    window.open(card.url, "_blank");
                  }
                } else {
                  handleClick(card.id);
                }
              }}
            >
              <div className={classes.titleCard}>
                <span>{lang === "en" ? card.titleEn : card.titleIt}</span>
              </div>
              <img src={card.img} alt={lang === "en" ? card.titleEn : card.titleIt} className={classes.demoCard2} />
            </div>

            <div className={classes.textCard}>
              <div className={classes.descriptionBox}>
                <p className={classes.descriptionText}>
                  {lang === "en" ? card.descEn : card.descIt}
                </p>
              </div>

              <div className={`${classes.flexButtons} d-flex justify-content-center align-items-center w-100 gap-2 flex-wrap mt-2`}>
                <div className={`${classes.demoCard2Button}`}>
                  {card.github && (
                    <a href={card.github} target="_black">
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                      >
                        <FaGithub className={classes.detailsIcon} />
                        Github
                      </button>
                    </a>
                  )}

                  {card.github2 && (
                    <a href={card.github2} target="_black">
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                      >
                        <FaGithub className={classes.detailsIcon} />
                        Fs api
                      </button>
                    </a>
                  )}

                  {card.url ? (
                    card.url.startsWith("/") ? (
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                        onClick={() => {
                          if (card.url === "/experiments/cloud-player" && window.innerWidth <= 768) {
                            window.open("http://cloud-player.webdemo.cloud/", "_blank");
                          } else {
                            navigate(card.url);
                          }
                        }}
                      >
                        <BiDetail className={classes.detailsIcon} />
                        View
                      </button>
                    ) : (
                      <a href={card.url} target="_blank" rel="noreferrer">
                        <button
                          type="button"
                          className={`${classes.detailsButton}`}
                        >
                          <BiDetail className={classes.detailsIcon} />
                          View
                        </button>
                      </a>
                    )
                  ) : (
                    <>
                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                        onClick={() => handleClick(card.id)}
                      >
                        <BiDetail className={classes.detailsIcon} />
                        View
                      </button>

                      <button
                        type="button"
                        className={`${classes.detailsButton}`}
                        onClick={() => handleClick3d(card.id)}
                      >
                        <BsBadge3D className={classes.detailsIcon} />
                        View
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperimentsCard;
